var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',{staticStyle:{"height":"calc(100vh - 70px)","width":"100%"},attrs:{"id":"map-section"}},[_c('WindyMap',{key:_vm.isWeatherMode,attrs:{"ships":_vm.assets}})],1):_c('div',{staticClass:"text-center text-danger my-2"},[_c('b-spinner',{staticClass:"align-middle"}),_c('strong',[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }